// Opens the printable parts list of an assembly in a new browser tab, ready to print.
// Produced by AssemblyPartsPDFController (GET /api/assemblies/pdf?assetId=123) and returned
// inline, so the browser renders it instead of downloading it.
export const openAssemblyPartsPdf = (
	assemblyAssetId: number | null | undefined,
): void => {
	if (typeof assemblyAssetId !== "number") return;

	window.open(`/api/assemblies/pdf?assetId=${assemblyAssetId}`, "_blank");
};
